import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header, { headerItemsLabels } from '../../../Common/Header/header';
import { gridsNames } from '../../../../enums/gridsNames';
import { FetchEntitiesFilters } from '../../../../enums/fetchEntitiesFilters';
import { ImportTypes, ImportAcceptFileTypes } from '../../../../enums/importTypes';
import { getEnumValue, enumTypes } from '../../../../utils/enumHelper';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import SpoolsGrid from './SpoolsGrid/spoolsGrid';
import {
  getLocationAssetTypes,
  getLocationAssetTypesForPrintPdfLabels, isFreezerLocation,
  isOutgoingOrIncomingLocation,
  isTransitArea
} from '../../../../utils/locationHelper';
import CreateSpool from '../Dialogs/CreateSpoolDialog/createSpoolDialog';
import {PL_DialogWrapper} from 'infrastructure/js/components/Dialog/dialog';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import {dialogsNames} from '../../../../enums/dialogsNames';

require('./spoolsView.scss');

export default class SpoolsView extends Component {
  constructor (props) {
    super(props);
    this.labels = createLabelHelper('mat.locationpage.view.assets.');
  }

  getDialogConfig = () => {
    return {
      // boEntityFilter: BO_EntityFilters.ACTIVE,
      boEntityFilter: [FetchEntitiesFilters.ACTIVE, FetchEntitiesFilters.ON_LOCATION],
      entitiesTypes: [getEnumValue(enumTypes.OBJECT_TYPE)('SPOOL')],
      preselectedAssets: this.props.sSelectedRowsData,
    };
  };

  getMoveAssetsDialogConfig = () => {
    let {sSelectedRowsData, sLocationDetails} = this.props;
    return {
      boEntityFilter: [
        FetchEntitiesFilters.ACTIVE,
      ],
      entitiesTypes: sSelectedRowsData?.size > 0 ? [getEnumValue(enumTypes.OBJECT_TYPE)('SPOOL')] :
        getLocationAssetTypes(sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('SPOOL')),
      preselectedAssets: this.props.sSelectedRowsData,
    };
  };

  isMoveToAvailable = (data) => {
    return data?.every(item => item.assetStatus === getEnumValue(enumTypes.ASSET_STATUS)('ACTIVE'));
  }

  isMarkAsReceivedAvailable = (data) => {
    return data?.every(item => item.assetStatus === getEnumValue(enumTypes.ASSET_STATUS)('TRANSIENT') ||
                               item.assetStatus === getEnumValue(enumTypes.ASSET_STATUS)('MISSING'));
  }

  getBringAssetsDialogConfig = () => {
    let {sLocationDetails} = this.props;
    return {
      boEntityFilter: [
        FetchEntitiesFilters.ACTIVE,
      ],
      entitiesTypes: getLocationAssetTypes(sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('SPOOL')),
    };
  };

  getImportConfig = () => {
    return {
      importTypes: [ImportTypes.IMPORT_SPOOLS],
      acceptFileTypes: [ImportAcceptFileTypes.CSV],
      parentComponent: this.onRefreshAll,
      shouldIncludeLocation: false, //import is done from a location , the import file locationId column is optional.
      showPrintLabels: true,
    };
  };

  getPrintPdfLabelsDialogConfig = () => {
    return {
      boEntityFilter: [FetchEntitiesFilters.ALL],
      preselectedAssets: this.props.sSelectedRowsData,
      entitiesTypes: getLocationAssetTypesForPrintPdfLabels(this.props.sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('SPOOL')),
    };
  };

  getAddToGroupDialogConfig = () => {
    let {sSelectedRowsData, sLocationDetails} = this.props;
    return {
      boEntityFilter: [FetchEntitiesFilters.ACTIVE, FetchEntitiesFilters.ON_LOCATION],
      preselectedAssets: sSelectedRowsData,
      entitiesTypes: sSelectedRowsData?.size > 0 ? [getEnumValue(enumTypes.OBJECT_TYPE)('SPOOL')] :
        getLocationAssetTypes(sLocationDetails, getEnumValue(enumTypes.OBJECT_TYPE)('SPOOL')),
    };
  };

  getEditLengthDialogConfig = () => {
    let payload = this.getDialogConfig();
    payload.editLengthOnly = true;
    return payload;
  };

  onRefreshAll = () => {
    this.props.actions?.reloadParentComponent();
  };

  getHeaderItems() {
    let { actions, sHasRows, sSelectedRowsData, sLocationDetails, loading } = this.props;
    let dialogConfig = this.getDialogConfig();
    let importConfig = this.getImportConfig();

    let selectedRowsData = this.props.sShipmentsGridData
      ? this.props.sShipmentsGridData.get('selectedRowsData')
      : [];

    let items = {
      title: this.labels.get('title.spools'),
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
          actionData: {gridName: gridsNames.LOCATION_ASSET_SPOOLS}
        },
        {
          id: 'refresh',
          label: '',
          icon: 'pl pl-refresh',
          action: this.onRefreshAll,
          tooltip: headerItemsLabels.REFRESH_ALL,
          disabled: loading,
        },
        ///EDIT LENGTH BUTTON (for Trial org only)
        ...(PermissionManager.editLengthInFreezerPermissions() && isFreezerLocation(sLocationDetails)
          ? [
              {
                id: 'editLength',
                label: headerItemsLabels.EDIT_LENGTH,
                icon: 'pl pl-edit-icon header-button',
                action: actions.headerActions.onMenuItemEditAssetAttributesClick,
                actionData: this.getEditLengthDialogConfig(),
                disabled: loading,
              },
            ]
          : []),
        {
          id: 'moveTo',
          label: headerItemsLabels.MOVE_TO,
          icon: 'pl pl-move-assets',
          counter: sSelectedRowsData.size,
          action: actions.headerActions.onMenuItemMoveToClick,
          actionData: this.getMoveAssetsDialogConfig(sSelectedRowsData),
          disabled: loading || !this.isMoveToAvailable(sSelectedRowsData),
        },
        {
          id: 'bringHere',
          label: headerItemsLabels.BRING_HERE,
          icon: 'pl pl-bring-assets',
          action: actions.headerActions.onMenuItemBringHereClick,
          actionData: this.getBringAssetsDialogConfig(),
          disabled: loading,
        },
      ],

      kebab: {
        disabled: loading || isOutgoingOrIncomingLocation(sLocationDetails),
        menuItems: [
          ...(PermissionManager.hasUpdateShelfLifePermissions()
            ? [
                {
                  id: 'updateShelfLife',
                  label: headerItemsLabels.UPDATE_SELF_LIFE,
                  disabled: !sHasRows,
                  action: actions.headerActions.onUpdateShelfLifeClick,
                  actionData: dialogConfig,
                },
              ]
            : []),

          ...(PermissionManager.hasCreateAssetsPermissions()
            ? [
                {
                  id: 'createSpool',
                  label: headerItemsLabels.CREATE_SPOOL,
                  action: actions.headerActions.onCreateSpoolClick,
                  // actionData: this.getDialogConfig
                },
              ]
            : []),

          {
            id: 'assignTag',
            label: headerItemsLabels.ASSIGN_TAG,
            action: actions.headerActions.onShowAssignRemoveAssetsTagsDialog,
            actionData: {
              activeDialog: dialogsNames.ASSIGN_REMOVE_ASSETS_TAGS_DIALOG,
              dialogData: { mode: 'ASSIGN' },
            },
          },
          {
            id: 'removeTag',
            label: headerItemsLabels.REMOVE_TAG,
            action: actions.headerActions.onShowAssignRemoveAssetsTagsDialog,
            actionData: {
              activeDialog: dialogsNames.ASSIGN_REMOVE_ASSETS_TAGS_DIALOG,
              dialogData: { mode: 'REMOVE' },
            },
          },

          ...(PermissionManager.hasArchiveAssetsPermissions()
            ? [
                {
                  id: 'archive',
                  label: headerItemsLabels.ARCHIVE,
                  action: actions.headerActions.onMenuItemArchiveClick,
                  actionData: dialogConfig,
                  disabled: !sHasRows,
                },
              ]
            : []),

          {
            id: 'export',
            label: headerItemsLabels.EXPORT_SPOOLS_LIST,
            action: actions.headerActions.export,
            actionData: { gridName: gridsNames.LOCATION_ASSET_SPOOLS },
            disabled: !sHasRows,
          },

          // {             //TODO: L SPOOLS not relevant for phase 1
          //   id:'exportSpoolsUsage',
          //   label: headerItemsLabels.EXPORT_SPOOLS_USAGE,
          //   action: actions.headerActions.exportUsage,
          //   actionData:{gridName: gridsNames.LOCATION_ASSET_SPOOLS},
          // },

          ...(PermissionManager.hasGroupAssetPermissions() &&
          PermissionManager.getOrgPreferences().groupsEnabled
            ? [
                {
                  id: 'addToGroup',
                  label: headerItemsLabels.ADD_TO_GROUP,
                  disabled: !sHasRows,
                  action: actions.headerActions.onAddToGroupDialogClick,
                  actionData: this.getAddToGroupDialogConfig(),
                },
              ]
            : []),

          ...(PermissionManager.hasEditAttributesPermissions()
            ? [
                {
                  id: 'editAttributes',
                  label: headerItemsLabels.EDIT_ATTRIBUTES,
                  disabled: !sHasRows,
                  action: actions.headerActions.onMenuItemEditAssetAttributesClick,
                  actionData: dialogConfig,
                },
              ]
            : []),

          ...(PermissionManager.hasImportAssetsPermissions()
            ? [
                {
                  id: 'importSpools',
                  label: headerItemsLabels.IMPORT_SPOOLS,
                  action: actions.headerActions.importItems,
                  actionData: importConfig,
                },
              ]
            : []),

          ...(PermissionManager.hasImportAssetsPermissions()
            ? [
                {
                  id: 'importSpoolsViaBarcode',
                  label: headerItemsLabels.IMPORT_SPOOLS_VIA_BARCODE,
                  action: actions.headerActions.onImportAssetsViaBarcodeClick,
                  actionData: { importType: ImportTypes.IMPORT_SPOOLS },
                },
              ]
            : []),

          ...(PermissionManager.hasEditAttributesPermissions()
            ? [
                {
                  id: 'importAttributesUpdate',
                  label: headerItemsLabels.IMPORT_ATTRIBUTES_UPDATE,
                  action: actions.headerActions.onMenuItemImportAttributesUpdateClick,
                  actionData: { importType: getEnumValue(enumTypes.IMPORT_TYPE)('UPDATE_SPOOL') },
                },
              ]
            : []),

          {
            id: 'printRfidTags',
            label: headerItemsLabels.PRINT_RFID_TAGS,
            action: actions.headerActions.onMenuItemPrintRfidTagsClick,
            actionData: dialogConfig,
            disabled: !sHasRows,
          },

          ...(PermissionManager.getOrgPreferences().printZplGenericAssetEnabled
            ? [
                {
                  id: 'printEmptyTags',
                  label: headerItemsLabels.PRINT_EMPTY_TAGS,
                  action: actions.headerActions.onMenuItemPrintEmptyRfidTagsClick,
                },
              ]
            : []),

          {
            id: 'printPdfLabels',
            label: headerItemsLabels.PRINT_LABEL,
            action: actions.headerActions.onMenuItemPrintLabelClick,
            actionData: this.getPrintPdfLabelsDialogConfig(),
          },
        ],
      },
    };
    isTransitArea(sLocationDetails) &&
      items.buttons.splice(items.buttons.length - 1, 1) &&
      items.kebab.menuItems.splice(0, items.kebab.menuItems.length, {
        id: 'markSpoolsAsReceived',
        label: headerItemsLabels.MARK_AS_RECEIVED,
        action: this.props.actions.headerActions.markAsReceived,
        actionData: {
          actionData: sSelectedRowsData,
          parentComponent: this.onRefreshAll,
        },
        disabled: sSelectedRowsData?.size === 0 || !this.isMarkAsReceivedAvailable(sSelectedRowsData)
      });
    return items;
  }

  render() {
    let headerItems = this.getHeaderItems();
    return (
      <div className="spools-view">
        <Header {...headerItems} />

        <SpoolsGrid actions={{...this.props.actions.assetsSpoolsGridActions, ...this.props.actions.fetchEntitiesActions}}
          locationDetails={this.props.sLocationDetails}
          cellAction={this.props.actions.getAssetRelatedAssets}
        />

        <PL_DialogWrapper dialogComponent={CreateSpool}
                          show={this.props.sDataCreateSpool.get('show')}
                          actions={this.props.actions.createSpoolActions}
                          sData={this.props.sDataCreateSpool}
        />
      </div>
    );
  }
}

SpoolsView.propTypes = {
  actions: PropTypes.object.isRequired,
  sHasRows: PropTypes.bool.isRequired,
  sSelectedRowsData: PropTypes.object,
  sLocationDetails: PropTypes.object.isRequired,
};
